import { Container, StyledInput, Legend, ViewPassword } from "./style";

const InputFieldPassword = ({
  value,
  onChange,
  placeholder,
  showPassword,
  setShowPassword,
  handleKey
}) => {
  return (
    <Container>
      <StyledInput
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        onKeyDown={handleKey}
      />
    </Container>
  );
};

export default InputFieldPassword;
